/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  IonApp,
  IonToolbar,
  IonContent,
  IonList,
  IonSelect,
  IonSelectOption,
  IonRow,
  IonGrid,
  IonModal,
  IonCol,
  IonMenuToggle,
  IonLabel,
  IonPage,
  IonButtons,
  IonButton,
  IonItem,IonInfiniteScroll,IonInfiniteScrollContent, IonIcon, IonRadioGroup,IonRadio
} from "@ionic/react";
import { arrowBack } from 'ionicons/icons'
import { usePapaParse } from 'react-papaparse';

import React, { useState } from "react";
import { DatePicker, Pagination } from "antd";
import "../styles/NewDeliveryComponent.css";
import "../styles/style.css";
import SidebarComponent from "./SidebarComponent";
import HeaderComponent from "./HeaderComponent";
import { getMemberProfile } from "../pages/newDelivery/services/apiService"
import { handleDownload, handleSelectedDate , getTripCount, handleGetTopics, handleCreateTopic,
  handleTripPagination } from "../pages/deliveries/services/handler"
import { useEffect } from "react";
import { getTrips} from "../pages/deliveries/services/apiService"
import {bookingStatusDecode} from "../utils/bookingStatus"
import TripDetailModal from "./TripDetailModal";
import {getTripDetail, cancelBooking} from "../pages/deliveries/services/apiService"
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import { trendingUp } from "ionicons/icons";
import * as DOMPurify from 'dompurify';
import 'react-toastify/dist/ReactToastify.css';
import { Spin } from 'antd';



function AllDeliveriesComponent(props) {

  const [page, setPage] = useState({
    pageNumber : 1,
    pageSize : 15
  })
  const [userSelectedTab, setUserSelectedTab] = useState('')
  const [startTime, setStartTime] = useState("")
  const [endTime, setEndTime] = useState("")
  const [deliveriesList , setDeliveriesList] = useState({})

  const [openSupportModal, setOpenSupportModal] = useState(false)
  const [openTripDetailsModal, setOpenTripDetailsModal] = useState(false)
  const [openCancelModal, setOpenCancelModal] = useState(false)
  const [cancellationReason, setCancellationReason] = useState("")
  const [otherCancellationReason, setOtherCancellationReason] = useState("")
  const [selectedTripId, setSelectedTripId] = useState(false)
  const [selectedBooking, setSelectedBooking] = useState({})
  const [tripCount, setTripCount] = useState({
    countAllBooking: 0 ,
    countOngoingBooking : 0 ,
    countCompletedBooking : 0 ,
  })
  const [showFormData, setShowFormData] = useState(false)
  const [rydeHelpTopicListForJobId , setRydeHelpTopicListForJobId] = useState([])
  const [userSelectedTopic, setUserSelectedTopic] = useState({})
  const [rydeHelpFormData, setRydeHelpFormData] = useState({})
  const [showSpinner, setShowSpinner] = useState(true)
  
  const { RangePicker } = DatePicker;

  useEffect(()=>{
    setShowSpinner(() => true)
    setUserSelectedTab('all')
    handleSelectedDate('all', undefined, setDeliveriesList, setStartTime, setEndTime, moment().subtract(90, 'days').unix(), moment().unix(), setUserSelectedTab)
    getTripCount(setTripCount, setShowSpinner)
    sessionStorage.clear()
    setShowSpinner(() => false)
  }, [])
  const { jsonToCSV } = usePapaParse();

  function purifyHtmlString  (htmlString)  {
    return DOMPurify.sanitize(htmlString);
  }

  function handleRydeHelpFormDataUpdate (inputKey, inputData) {
    setRydeHelpFormData({...rydeHelpFormData, [`${inputKey}`]: inputData })
  }

  function notify (msg) {
    toast(msg)
  }


  return (
    <> 
    <HeaderComponent></HeaderComponent>
      <SidebarComponent activeMenu={['sidemenu-list', 'sidemenu-list', 'sidemenu-list active']}/>
      {
        showSpinner && <Spin />
      }
      { !showSpinner &&
        <div className="details-popup ">
        <IonApp className="details-popup">
          <IonPage className="ion-page core-wrapper" id="main-content">
            <IonToolbar className="header-toolbar">
              <IonButtons slot="start" className="home-btn">
                <IonMenuToggle>
                  <IonButton>
                    <img src="../img/menu-icon.png" />
                  </IonButton>
                </IonMenuToggle>
              </IonButtons>
              <img className="header-logo" src="../img/logo.png" />
            </IonToolbar>
           
            <IonContent className="ion-padding page-title">
                          <div className="wrapper dashboard-page  option-1 option-1-1">
                            <ion-breadcrumbs>
                              <ion-breadcrumb href="new-delivery">
                                New Delivery
                              </ion-breadcrumb>
                              <ion-breadcrumb href="">All Deliveries</ion-breadcrumb>
                            </ion-breadcrumbs>
                            <h1>All Deliveries</h1>
                            <div className="action-table">
                                <IonSelect 
                                  placeholder="Export"
                                  onIonChange={async (e) => {
                                    let dataDownloaded = await handleDownload(e.target.value , startTime, endTime, jsonToCSV)
                                    if(!dataDownloaded) {
                                      toast("No Trips present for the selected dates")
                                    } 
                                  }}
                              >
                                <IonSelectOption value="pdf">
                                  PDF
                                </IonSelectOption>
                                <IonSelectOption value="csv">
                                  CSV
                                </IonSelectOption>
                              </IonSelect>   
                              <RangePicker
                                  onChange={(val) => handleSelectedDate(userSelectedTab, val, setDeliveriesList,  setStartTime, setEndTime, startTime, endTime, setUserSelectedTab)}
                                />
                                
                          </div>

                <div className="trip-details">

                      <div className="tabs">
                          <div className='tab-header-trips'>
                              <div className="tab" >
                                  <input type="radio" className='first-tab' id="tab-1" name="tab-group-1" onClick={()=>{handleSelectedDate('all', undefined, setDeliveriesList,setStartTime,setEndTime, startTime, endTime, setUserSelectedTab)}} />
                                  <label htmlFor="tab-1">
                                      <img src="img/all-list.svg"/>
                                      <h2>All ({tripCount.countAllBooking})</h2>
                                      
                                  </label>
                              </div>

                              <div className="tab">
                                  <input type="radio" id="tab-2" name="tab-group-1" onClick={()=>{handleSelectedDate('on-going', undefined, setDeliveriesList,setStartTime,setEndTime, startTime, endTime, setUserSelectedTab)}} />
                                  <label htmlFor="tab-2">
                                  <img src="img/inprogress-trip.svg"/>
                                      <h2>On Going ({tripCount.countOngoingBooking})</h2>
                                     
                                  </label>
                              </div> 
                              <div className="tab">
                                  <input type="radio" id="tab-3" name="tab-group-1" onChange={(val) => handleSelectedDate('completed', undefined, setDeliveriesList,setStartTime,setEndTime, startTime, endTime, setUserSelectedTab)}  />
                                  <label htmlFor="tab-3">
                                  <img src="img/done-trip.svg"/>
                                      <h2>Completed ({tripCount.countCompletedBooking})</h2>
                                     
                                  </label>
                              </div>
                          </div>
                      </div>
                  
                </div>

                {deliveriesList.result && deliveriesList.result.length === 0 &&
                    <div className="trip-list">
                      <IonGrid>
                        <IonRow>
                          <p className="no-bookings"> No {userSelectedTab} bookings</p>
                        </IonRow>
                      </IonGrid>
                    </div>
                }
                { deliveriesList.result && deliveriesList.result.length > 0 && 
                  <div className="trip-list">
                    <IonGrid>
                      {
                        deliveriesList.result.map((tripDetails)=>{
                          return (
                            <>
                              <IonRow>
                                  <IonCol size="6">
                                      <div className="sender-location">  
                                          <img src="../img/last-location.svg" />
                                          <p>{ tripDetails.startPlace}</p>
                                          <small>{tripDetails.senderName}</small>
                                       </div>
                                       <div className="last-location">
                                           <p>{ tripDetails.endPlace }</p>
                                          <small>{ tripDetails.receiverName }</small>
                                        </div>
                                  </IonCol>
                                  <IonCol size="6">
                                      <div className="trip-action">
                                      { userSelectedTab === 'on-going' &&
                                      <>
                                      <a className="info-details" onClick={async()=>{let response = await getTripDetail(tripDetails.id);window.open(`${response.result.shareUrl}`); }}><img src="img/track.svg" /> Track</a> 
                                      <a className="info-details" onClick={async() => {setSelectedTripId(tripDetails.id);setSelectedBooking(tripDetails); setOpenCancelModal(true)}}><img src="img/cancel.svg" /> Cancel</a> 
                                      </>
                                      }
                                      <a className="support" onClick={async()=>{setSelectedTripId(tripDetails.id); 
                                      await handleGetTopics(tripDetails.id , setRydeHelpTopicListForJobId)
                                      setOpenSupportModal(true)
                                       
                                      
                                      }}><img src="img/help.svg" /> Support</a> 
                                      <a className="info-details"  onClick={()=>{setSelectedTripId(tripDetails.id); setOpenTripDetailsModal(true); }}><img src="img/info.svg" /> Details</a> 
                                      <span 
                                      // className="status" 
                                      className={bookingStatusDecode(tripDetails.status)[1]}
                                       >{bookingStatusDecode(tripDetails.status)[0]}</span>
                                      
                                      </div>
                                  </IonCol>
                              </IonRow>
                            </>
                          )
                        })
                      }
                      



                    </IonGrid>
                  </div>
                }

              

                      <IonModal isOpen={openTripDetailsModal}>
                        <TripDetailModal tripId={selectedTripId} setIsOpen={setOpenTripDetailsModal}/>
                      </IonModal>

                      <IonModal isOpen={openSupportModal}>
                        <IonContent className="ion-padding view-details-popup">
                          <div className='popup-header'>
                            <IonGrid>
                              <p  className='close-outline' onClick={() => {setShowFormData(false); setUserSelectedTopic({});
                                setOpenSupportModal(false)}}>X</p>
                            <IonRow>
                              <IonCol size="7">
                                <h1>Customer Support</h1>
                                <p>Trip Id {selectedTripId} </p>
                              </IonCol>
                              <IonCol size="5">
                                <p>RydeHelp</p>
                              </IonCol>
                            </IonRow>
                            </IonGrid>
                          </div>
                          <div className='order-summary view-details-popup'>
                        <IonGrid>
                        <div className='top-grid'>
                        <IonRow>
                      <IonCol>

                        { !showFormData &&
                        <>
                        {/* Just Updated the list of topics here */}
                        {
                          <div className="cancel-list">
                            {rydeHelpTopicListForJobId && rydeHelpTopicListForJobId.map((d , i) => {
                                return (
                                  <>
                                  <a onClick={()=>{setShowFormData(true); setUserSelectedTopic(rydeHelpTopicListForJobId[i])}}>
                                    {d.topicTitle}
                                    <img className="right-arrow" src="../img/right-arrow.svg" />
                                  </a>
                                  </>
                                )
                            })}
                          </div>
                        }
                        
                        </>
                        }

                        {
                          showFormData &&
                          <>
                            {
                              
                              <>
                              
                              <div onClick={()=>{
                                                  setShowFormData(false);
                                                  setUserSelectedTopic({})
                                                  }}><IonIcon icon={arrowBack} size={'large'}/></div>
                              <div  dangerouslySetInnerHTML={{ __html: purifyHtmlString(userSelectedTopic.topicContent) }} ></div>
                              
                              <br/>
                              </>
                                
                              
                                
                              
                            }
                            {
                              <div>
                              {
                                userSelectedTopic.formData && userSelectedTopic.formData.map((d)=>{
                                  return (
                                    <>
                                    <div >
                                    <p><b>{d.inputTitle}</b></p>
                                    <textarea placeholder={d.inputPlaceholder} onChange={(e)=>{
                                      handleRydeHelpFormDataUpdate(d.inputKey, e.target.value)
                                    }}></textarea>
                                    </div>
                                    </>
                                  )
                                })
                              }
                              </div>
                            }
                            <IonButton color="primary"horizontal="end" size="medium" mode='ios' onClick={async() => {
                               let result = await handleCreateTopic({
                                "topicId" : userSelectedTopic.topicId ,
                                "tripId"  : selectedTripId ,
                                ...rydeHelpFormData
                             })                  

                             notify(result.result.msg)
                              
                              setOpenSupportModal(false); setShowFormData(false)}}>Submit Request</IonButton>

                          </>
                        }
                      


                      </IonCol>
                     
                    </IonRow>

              </div>
                    
                    
                  </IonGrid>
                  </div>
                 </IonContent>
                 
                      </IonModal>

                      <IonModal isOpen={openCancelModal}>
                        <IonContent className="ion-padding view-details-popup">
                          <div className='popup-header'>
                            <IonGrid>
                              <p  className='close-outline' onClick={() => setOpenCancelModal(false)}>X</p>
                            <IonRow>
                              <IonCol size="7">
                                <h1>Confirm Cancellation</h1>
                                <p>Trip Id {selectedTripId} </p>
                              </IonCol>
                            </IonRow>
                            </IonGrid>
                          </div>
                          <div className='order-summary view-details-popup'>
                        <IonGrid>
                        <div className='top-grid cancel-list'>
                        <IonRow>
                      <IonCol>
                        {
                          selectedBooking.status === 0 && 
                          <>
                            <p>A Cancellation Fee compensates drivers for the time and effort they spend getting to your location. You will be 
                              charged a $5.30 cancellation fee if you cancel after <b>{moment.unix(selectedBooking.time).format('hh:mm a')}</b>
                            </p>
                            <p>
                              <b>
                                Your feedback is important to us! Tell us why you are cancelling:
                              </b>
                            </p>
                            <IonList>
                              <IonRadioGroup value={cancellationReason}>
                                  <IonItem>
                                    <IonLabel>Driver is not moving</IonLabel>
                                    <IonRadio slot="end" value="Driver is not moving" onClick={(e) => {setCancellationReason(e.target.value)}} ></IonRadio>
                                  </IonItem>

                                  <IonItem>
                                    <IonLabel>Driver is uncontactable</IonLabel>
                                    <IonRadio slot="end" value="Driver is uncontactable" onClick={(e) => {setCancellationReason(e.target.value)}} ></IonRadio>
                                  </IonItem>

                                  <IonItem>
                                    <IonLabel>Driver asked to cancel</IonLabel>
                                    <IonRadio slot="end" value="Driver asked to cancel" onClick={(e) => {setCancellationReason(e.target.value)}}></IonRadio>
                                  </IonItem>

                                  <IonItem>
                                    <IonLabel>Driver is too far away</IonLabel>
                                    <IonRadio slot="end" value="Driver is too far away" onClick={(e) => {setCancellationReason(e.target.value)}} ></IonRadio>
                                  </IonItem>

                                  <IonItem>
                                    <IonLabel>Others</IonLabel>
                                    <IonRadio slot="end" value="Others" onClick={(e) => {setCancellationReason(e.target.value)}}></IonRadio>
                                  </IonItem>


                              </IonRadioGroup>
                            </IonList>

                            { cancellationReason === 'Others' &&
                            <div>
                            <textarea  onChange={ (e) => { setOtherCancellationReason(e.target.value)} }></textarea>
                            </div>
                            }

                          </>
                        }

                        {
                          selectedBooking.status !== 0 && 
                          <>
                            <p>You're cancelling 4 min after getting a driver, a cancellation fee will be applied.This will compensate the driver for their time.
                            </p>
                            <p>
                              
                              <b>
                              Total
                              </b> (Inclusive of platform fee): <b>$5.30</b>
                            </p>
                            <IonList>
                              <IonRadioGroup value={cancellationReason}>
                                  <IonItem>
                                    <IonLabel>Driver is not moving</IonLabel>
                                    <IonRadio slot="end" value="Driver is not moving" onClick={(e) => {setCancellationReason(e.target.value)}} ></IonRadio>
                                  </IonItem>

                                  <IonItem>
                                    <IonLabel>Driver is uncontactable</IonLabel>
                                    <IonRadio slot="end" value="Driver is uncontactable" onClick={(e) => {setCancellationReason(e.target.value)}} ></IonRadio>
                                  </IonItem>

                                  <IonItem>
                                    <IonLabel>Driver asked to cancel</IonLabel>
                                    <IonRadio slot="end" value="Driver asked to cancel" onClick={(e) => {setCancellationReason(e.target.value)}}></IonRadio>
                                  </IonItem>

                                  <IonItem>
                                    <IonLabel>Driver is too far away</IonLabel>
                                    <IonRadio slot="end" value="Driver is too far away" onClick={(e) => {setCancellationReason(e.target.value)}} ></IonRadio>
                                  </IonItem>

                                  <IonItem>
                                    <IonLabel>Others</IonLabel>
                                    <IonRadio slot="end" value="Others" onClick={(e) => {setCancellationReason(e.target.value)}}></IonRadio>
                                  </IonItem>


                              </IonRadioGroup>
                            </IonList>
                            { cancellationReason === 'Others' &&
                            <div>
                            <textarea  onChange={ (e) => { setOtherCancellationReason(e.target.value)} }></textarea>
                            </div>
                            }
                          </>
                        }
                      
                      <IonButton color="primary"horizontal="end" size="medium" mode='ios' onClick={() => setOpenCancelModal(false)}>Continue with trip</IonButton> 
                      <IonButton color="primary"horizontal="end" size="medium" mode='ios' onClick={async() => {
                        let response = await cancelBooking(selectedTripId, cancellationReason, otherCancellationReason );
                        if (response.data.status) {
                          window.location.reload(true);
                          setOpenCancelModal(false)
                          setUserSelectedTab('all')
                        }
                        
                        }}>Cancel Booking</IonButton> 
                      </IonCol>
                     
                    </IonRow>

              </div>
                    
                    
                  </IonGrid>
                  </div>
                 </IonContent>
                      </IonModal>
              </div>
              <IonInfiniteScroll
                    onIonInfinite={async (ev)=>{
                      
                       await handleTripPagination("all", page.pageNumber, page.pageSize, setDeliveriesList, setPage)
                       
                       ev.target.complete(); 
                      }}
              >
              <IonInfiniteScrollContent loadingSpinner="bubbles"></IonInfiniteScrollContent>
              </IonInfiniteScroll>
            </IonContent>
          </IonPage>
        </IonApp>
        </div>
      }

       <ToastContainer
      position="bottom-left" 
      theme="light"
      pauseOnHover/> 
    </>
  );
}

export default AllDeliveriesComponent;
